import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {IddTrainingService} from "../../../shared/services/idd-training.service";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CertificateOverviewDialogData} from "../idd-certificate-edit-dialog/idd-certificate-edit-dialog.component";
import {IddTrainingCertificate} from "../../../shared/interface/idd-training-certificate";

@Component({
  selector: 'app-deny-idd-certificate-dialog',
  templateUrl: './deny-idd-certificate-dialog.component.html',
  styleUrls: ['./deny-idd-certificate-dialog.component.scss']
})
export class DenyIddCertificateDialogComponent implements OnInit {

  iddTrainingCertificateId: string;
  certificate: IddTrainingCertificate;
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<DenyIddCertificateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CertificateOverviewDialogData,
    private fb: FormBuilder,
    private router: Router,
    private iddTrainingService: IddTrainingService,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.iddTrainingCertificateId = data.certificateId;
    this.certificate = data.certificateObject;
  }
  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close(this.reason); // zwraca powód
  }

  onCancel(): void {
    this.dialogRef.close(null); // anuluj
  }

}
